import type {ProjectDetail} from 'src/projects/schemas'

export function orderLabel(order: Pick<ProjectDetail, 'orderNumber' | 'name'>): string {
    return order.orderNumber ?? order.name
}
